<template>
  <b-container @keyup.enter="loginFormEnter" @keyup.esc="cancel">
      <b-row>
        {{targetName}}
      </b-row>
      <b-row class="mt-3">
        <b-col cols="2" class="mt-2"><label>帳號:</label></b-col>
        <!--autocapitalize=none not work, set input type to email instead-->
        <b-col cols="9"><b-form-input ref="form_input_account" v-model="loginAccount" type="email"></b-form-input></b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="2" class="mt-2"><label>密碼:</label></b-col>
        <b-col cols="9" v-if="!showClearPwd" ><b-form-input ref="form_input_pwd" name="loginpwd" v-model="loginPwd" type="password"></b-form-input></b-col>
        <b-col cols="9" v-if="showClearPwd" ><b-form-input ref="form_input_pwd" name="loginpwd" v-model="loginPwd" type="text"></b-form-input></b-col>
      </b-row>
      <b-row>
        <b-col cols="5"><b-form-checkbox v-model="showClearPwd">顯示密碼</b-form-checkbox></b-col>
      </b-row>
      <b-row v-if="$bus.getRole()=='merchant'||$bus.getRole()=='spalogin'"><b-col cols="2"/><span class="link-span ml-3" title="店長管理帳號密碼重設點這裡,店家子帳號請直接找店長重設" @click="goFogetPwd" >忘記管理密碼?</span></b-row>
      <b-row>
        <b-alert 
          dismissible
          fade
          variant="danger"
          :show="dismissCountDown"
          @dismissed="dismissCountDown=0"
          
          class="m-1"
        >
          <span v-html="errorPrompt"></span>
        </b-alert>
      </b-row>
      <b-row class="mt-2">
        <b-col><b-button id='modalCancel' @click="cancel">取消</b-button></b-col>
        <b-col><b-button id='modalOK' ref="btnModalOK" :class="waiting?'enter-waiting':''" :disabled="waiting" @click.stop.prevent="ok">確定</b-button></b-col>
      </b-row>
  </b-container>
</template>

<script>
import {
  apiLogin
} from '@/api/AdminManage.js'

export default {
  name: 'Login',
  data: function () {
    return {
      waiting:false,
      loginAccount:"",
      loginPwd:"",
      showClearPwd:false,
      errorPrompt: String,
      dismissSecs: 5,
      dismissCountDown: 0,
    }
  },
  props: [
    'loginTarget',
    'OKCallback',
    'CancelCallback'
    ],
  methods: {
    goFogetPwd() {
      window.location.hash = "#merchantreset"
      window.history.go(0)
    },
    initialize: function () {
      this.waiting = false
    },
    ok: function (evt) {
      evt.preventDefault()
      // this.waiting = true
      let loginParam = {
        account: this.loginAccount,
        password: this.loginPwd,
      }
      let target_role = 'merchant_admin'
      loginParam['module'] = 'merchant'
      loginParam['method'] = 'merchant_login'
      if (this.loginTarget == 'admin') {
        target_role = 'business_admin'
        loginParam['module'] = 'admin_manage'
        loginParam['method'] = 'admin_login'
      }
      else if (this.loginTarget == 'user') {
        //暫時不提供user的web,但架構規劃可以先留(如果view有responsive,那之後用web也可以預約,反正功能都差不多)
        target_role = 'app_user'
        loginParam['module'] = 'user'
        // 後端增加一個取得authenticate並登入的api來驗證帳密
        // 同一個api主機產生的authenticate會不會有衝突風險目前未知
        // 這個功能僅限會員帳密登入,尚不支援fb與google登入
        loginParam['method'] = 'user_login'
        //loginParam['method'] = 'user_verify_login'
        //loginParam['user_id'] = 30058
      }
      if (target_role === 'app_user') {
        // loginParam['user_id'] = 8826
      }
      // eslint-disable-next-line
      // console.log(loginParam)
      if (this.$bus.line_token && this.$bus.line_uid) {
        loginParam.access_token = this.$bus.line_token
        loginParam.line_id = this.$bus.line_uid
      }
      let vm = this
      apiLogin(loginParam).then(function(resp){

        let data = resp.data
        if (data.ok === 0) {
          vm.dismissCountDown = vm.dismissSecs
          vm.errorPrompt = data.msg
          vm.waiting = false
          return
        }
        vm.dismissCountDown = 0
        vm.OKCallback(data.data)
      }).catch(function(error){

        if (!error.response) {
          let error_param = {
            type: 'error',
            title: '系統異常',
            icon: 'error',
            error_code: vm.$bus.createErrorCode(vm.$options.name),
            error_message: vm.$bus.pageCodeMapper[vm.$options.name].name + '發生異常',
            content: error.stack.toString() 
          }
          console.log(error_param)
          vm.$alert(error_param)
          return
        }

        let data = error.response.data
        console.log(data)
        if (data.ok === 0) {
          vm.dismissCountDown = vm.dismissSecs
          vm.errorPrompt = data.msg
          vm.waiting = false
          return
        }

      })

      // this.$bus.apiCall(loginParam, function (data, vm) {
      //   vm.dismissCountDown = 0
      //   if (data.ok === 0) {
      //     vm.dismissCountDown = vm.dismissSecs
      //     vm.errorPrompt = data.msg
      //     vm.waiting = false
      //     return
      //   }
      //   vm.OKCallback(data.data)
      // },this)
      
      /*genericApiResult(loginParam).then(data => {
        this.dismissCountDown = 0
        if (data.ok === 0) {
          this.dismissCountDown = this.dismissSecs
          this.errorPrompt = data.msg
          return
        }
        if (data.ok === 0) {
          this.$emit('modalLoginClose')
        }
        
      }, reject => {
        alert('error ' + reject)
      })*/
      
    },
    cancel: function () {
      this.CancelCallback();
    },
    loginFormEnter: function (event) {
      this.ok(event)
    }
  },
  computed: {
    targetName() {
      switch (this.loginTarget) {
        case 'user':
          return '耐德會員'
        case 'merchant':
        case 'spalogin':
          return '店家/供應商'
        case 'admin':
          return '耐德票券預約後台'
        default:
          return '你是誰？'
      }
    }
  }, 
  created: function () {
    this.waiting = false
    // 不管是在created還是mounted直接設focus都無效,必須timeout等一下
    setTimeout(() => {
      
    }, 500);
    // foucs on account
    // eslint-disable-next-line
    // console.log(this.$refs)
    //
  },
  mounted() {
    const account = this.getQueryVariable('account')
    if (account) {
      this.loginAccount = account
      window.location.hash = window.location.hash.substr(0,window.location.hash.indexOf('?'))
      setTimeout(() => {
        this.$refs.form_input_pwd.focus()
      }, 1000);
    }
    else {
      if (this.$refs.form_input_account) {
        this.$refs.form_input_account.focus()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.enter-waiting {
  cursor:wait;
}
.link-span {
  cursor:pointer;
  color:blue;
  text-decoration:underline;
}
.link-span:hover {
  text-decoration:none;
  text-shadow: 1px 1px 1px #555;
}
</style>
